import cardHeight from './_set-card-height';
import carousel from './_carousel';
import dataLayer from './_data-layer';
import facets from './_facets';
import mobileMenu from './_mobile-menu';
import modal from './_modal';
import pathToMemory from './_path-to-memory';

const { Vue } = window;

window.volExperts = new Vue({
  el: '#main',
  mixins: [
    cardHeight,
    carousel,
    dataLayer,
    facets,
    mobileMenu,
    modal,
    pathToMemory
  ]
});
